import React, { useState, useRef } from 'react';

import { translate } from '../../common/i18n/localize';

import { getRecaptchaKey } from '../../common/util/server-util';
import { isPasswordWeak } from '../../common/util/password-util';

import IString from '../../common/components/i-string';
import WaitButton from '../../common/components/wait-button';
import { HiddenInviteCode, HiddenProduct, HiddenRedirect, HiddenReferral, HiddenXSRF } from '../../common/components/forms';
import PasswordWithInfo from '../../common/components/forms/password/password-with-info';

function EmailRegisterForm() {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [pending, setPending] = useState(false);
  const [recaptcha, setRecaptcha] = useState('');
  const [weak, setWeak] = useState(false);

  const ref = useRef();

  const handleChangePassword = (password) => {
    setPassword(password);
    if (weak) {
      // only update if we've previously submitted a weak one;
      // this allows the user to clear the error
      setWeak(isPasswordWeak(password));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isPasswordWeak(password)) {
      setWeak(true);
      return;
    }

    setPending(true);
    
    const grecaptcha = window.grecaptcha;
    if (grecaptcha) {
      grecaptcha.execute(getRecaptchaKey(), { action: 'submit' }).then((token) => {
        setRecaptcha(token);
        ref.current.submit();
      });
    }
  };

  return (
    <form id="register" ref={ref} onSubmit={handleSubmit} method='post'>
      <HiddenInviteCode />
      <HiddenProduct />
      <HiddenRedirect />
      <HiddenReferral />
      <HiddenXSRF />

      <input type="hidden" name="recaptcha_token" value={recaptcha} />
      <fieldset className="chunk">
        <input 
          autoFocus
          name="email"
          placeholder={translate('placeholder.email')} 
          required
          type="email"  
          value={email || ''} 
          onChange={e => setEmail(e.target.value)} />
      </fieldset>
      <fieldset className="chunk">
        <PasswordWithInfo onChange={handleChangePassword} open={weak} />
      </fieldset>
      <fieldset className="chunk">
        <input type="text" placeholder={translate('placeholder.first_name')} name="first_name" required />
      </fieldset>
      <fieldset className="chunk">
        <input type="text" placeholder={translate('placeholder.last_name')} name="last_name" required />
      </fieldset>
      <fieldset className="actions noMarginAbove">
        <WaitButton id="register-submit" type='submit' wait={pending} >
          <IString stringKey='submit' />
        </WaitButton>
      </fieldset>
    </form>
  );
}

export default EmailRegisterForm;
